import arrow from './arrow.svg';

export default arrow;
